<template>
  <v-container v-if="!!instance">
    <toolbar :item="instance" mode="export" />
    <v-card flat>
      <ExportForm
        :predictions="predictions" 
        :connections="connections" 
        :techniques="techniques" 
        :instance="instance" 
        @submitted="onSubmit">
      </ExportForm>
    </v-card>
  </v-container>
</template>
<script>
import ExportForm from "@/components/Forms/Export"
import Exports from "@/api/exports"
import Connections from "@/api/connections"
import Predictions from "@/api/predictions"
import Techniques from "@/api/techniques"
import toolbar from "@/components/toolbar"
export default {
  name: "ExportCreate",
  components: {
    toolbar,
    ExportForm,
  },
  data() {
    return {
      predictions: [],
      techniques: [],
      connections: [],
      instance: null,
    }
  },
  mounted() {
    Exports.retrieve(this.$route.params.uuid).then(response => this.instance = response.data)
    Predictions.list().then(response => this.predictions = response.data.results)
    Connections.list().then(response => this.connections = response.data)
    Techniques.list().then(response => this.techniques = response.data )
  },
  methods: {
    onSubmit(data) {
      let payload = {
        prediction: data.prediction,
        config: data.config,
        owner: this.user.id
      }
      Exports.update(this.$route.params.uuid, payload).then(_ => {
        this.notify('Generating export...')
        this.$router.push({ name: 'exportList' })
      })
    }
  }
}
</script>